package dev.lingvo.shared.screenshots.color

/** Reduces chroma at fixed lightness and hue, avoiding channel clipping that would shift a brand hue. */
fun gamutMap(target: OkLch): String {
    require(target.l in 0.0..1.0 && target.c.isFinite() && target.c >= 0 && target.h.isFinite()) { "Invalid OKLCH target" }
    target.toLab().toSrgbHex()?.let { return it }
    var low = 0.0
    var high = target.c
    repeat(12) {
        val middle = (low + high) / 2
        if (target.copy(c = middle).toLab().toSrgbHex() == null) high = middle else low = middle
    }
    return requireNotNull(target.copy(c = low).toLab().toSrgbHex())
}
